// Import necessary Material-UI components
import Grid from "@mui/material/Grid";
import TextField from "@mui/material/TextField";
// Import custom Material-UI components
import { CustomSelect, CustomTextfield } from "./customMUIComponents";
import { CustomImagePicker } from "./CustomImagePicker.component";
import { productClasses } from "../functions";

export function ItemDetailsFormCommon({
  values,
  onChange,
  errors,
  productImage,
  setProductImage,
}) {
  return (
    <Grid container spacing={2}>
      <Grid item xs={12} sm={12}>
        {/* Render a TextField for the item ERP code */}
        <TextField
          name="itemERPCode"
          fullWidth
          id="itemERPCode"
          label="Item ERP Code (If Exists)"
          value={values.itemERPCode}
          onChange={onChange}
          error={errors && errors.itemERPCode && true}
          helperText={
            errors && errors.itemERPCode !== "" ? errors.itemERPCode : ""
          }
        />
      </Grid>
      {/* Map over an array of field names to render CustomTextfield components */}
      {[
        "itemDescription",
        "specification",
        "quantityForSample",
        "preferredUnitOfMeasure",
      ].map((item, index) => (
        <CustomTextfield
          id={item}
          values={values}
          errors={errors}
          onChange={onChange}
          gridValues={{ xs: 12, sm: 12 }}
          key={index}
        />
      ))}
      {/* Map over an array of objects to render CustomSelect components */}

      {[
        {
          name: "productClass",
          menuItems: productClasses,
        },
      ].map((item, index) => (
        <CustomSelect
          id={item.name}
          menuItems={item.menuItems}
          values={values}
          errors={errors}
          onChange={onChange}
          gridValues={{ xs: 12, sm: 12 }}
          key={index}
        />
      ))}
      {/* Render a CustomImagePicker component for selecting product images */}
      <Grid item xs={12} sx={{ mt: "-10px" }}>
        <CustomImagePicker
          error={errors && errors.productImage}
          selectedImages={productImage}
          setSelectedImages={setProductImage}
          pickerId=""
          multiple={true}
        />
      </Grid>
    </Grid>
  );
}
